/**
 * CanvasFormSnapshotRightSideView.js
 * Created by zl952fc on 11/23/2020.
 */

import React, {useState, useEffect, useMemo} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {IconoirMaximize} from '@ey-xd/motif-icon';
import {navigationIcFullscreen24px, navigationIcFullscreenExit24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {labels} from '../../../util/utils';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import HeaderList from './Header/HeaderList';
import RightSideSnapshotSelect from './RightSideSnapshotSelect';
import * as snapshotsactions from '../../../actions/Snapshot/snapshotsactions';
import * as snapshotdetailsactions from '../../../actions/Snapshot/snapshotdetailsactions';
import Icon from '../BaseComponentWrappers/MotifIcon';

function CanvasFormSnapshotRightSideView(props) {
	const {
		actions,
		rightSideSnapshotId,
		snapshotCompareDetails,
		engagementId,
		documentId,
		showHideSnapshotViewValue
	} = props;
	const [headerList, setHeaderList] = useState([]),
		[currentHeaderId, setCurrentHeaderId] = useState(0),
		[selectedSectionId, setSelectedSectionId] = useState(undefined),
		[snapShotList, setSnapShotList] = useState([]),
		[selectedSnapShot, setSelectedSnapShot] = useState(),
		[snapshotId, setSnapshotId] = useState(-1),
		[isFullViewRightSideSnapshot, setFullViewRightSideSnapshot] = useState(false),
		[showHideSnapshotView, setShowHideSnapshotView] = useState(false),
		[isLoading, setIsLoading] = useState(false),
		[selectedTargetSnapShotId, setSelectedTargetSnapShotId] = useState(-1);

	const onTargetSnapshotChange = (option) => {
		setSelectedSnapShot(option);
		setSelectedTargetSnapShotId(option.value);
		if (option.value > 0) {
			getSnapshotDetails(option.value, snapshotId);
		}
	};

	const getSnapshotDetails = (snapshotId, sourceSnapshotId) => {
		setIsLoading(true);
		actions
			.getSnapshotById(engagementId, documentId, snapshotId, sourceSnapshotId)
			.then(() => {
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	};

	const showToggleViewSnapshot = () => {
		actions.showHideLeftSideSnapshotView(isFullViewRightSideSnapshot);
		setShowHideSnapshotView(false);
		setFullViewRightSideSnapshot(!isFullViewRightSideSnapshot);
	};

	const showHeaderList = useMemo(() => {
		return (
			<HeaderList
				changesView
				isSnapshotView
				headers={headerList}
				headerId={currentHeaderId}
				selectedSectionId={selectedSectionId}
				setSelectedSectionId={setSelectedSectionId}
				engagementId={engagementId}
				documentId={documentId}
			/>
		);
	}, [headerList, currentHeaderId, selectedSectionId, setSelectedSectionId, engagementId, documentId]);

	useEffect(() => {
		if (showHideSnapshotViewValue === true || showHideSnapshotViewValue === false) {
			setShowHideSnapshotView(showHideSnapshotViewValue);
		}
	}, [showHideSnapshotViewValue]);

	useEffect(() => {
		setHeaderList(snapshotCompareDetails);
	}, [snapshotCompareDetails]);

	useEffect(() => {
		if (rightSideSnapshotId !== 0) {
			setSnapshotId(rightSideSnapshotId);
			setSelectedTargetSnapShotId(-1);
		}
	}, [rightSideSnapshotId]);

	return (
		<StyledCanvasFormChanges
			className={`CanvasFormSnapshotRightSideView ${isFullViewRightSideSnapshot ? 'FullView' : ''} ${
				showHideSnapshotView ? 'HideView' : ''
			}`}
		>
			{!showHideSnapshotView && (
				<>
					<section className="CanvasFormChangesHeader">
						<section className="CanvasFormSnapshotChangesHeader">
							<RightSideSnapshotSelect
								defaultselectedSnapShot={selectedSnapShot}
								onTargetSnapshotChange={onTargetSnapshotChange}
							/>
							<section
								className="IconToggleView"
								onClick={() => showToggleViewSnapshot()}
								title={!isFullViewRightSideSnapshot ? labels.defaultView : labels.fullView}
							>
								<Icon
									src={isFullViewRightSideSnapshot ? IconoirMaximize : IconoirMaximize}
									disabled={isFullViewRightSideSnapshot}
								/>
							</section>
						</section>
					</section>
					{selectedTargetSnapShotId > 0 && (
						<section className="CanvasFormChangesBody">
							<section className={`CanvasFormSnapshotChangesBody`}>
								{isLoading ? (
									<LoadingIndicator view="inlineView" styleName="relatedDocuments-loading" />
								) : (
									showHeaderList
								)}
							</section>
						</section>
					)}
				</>
			)}
		</StyledCanvasFormChanges>
	);
}

function mapState(storeState) {
	return {
		snapshotCompareDetails: storeState.snapshotCompareDetails,
		rightSideSnapshotId: storeState.clearRightSideSnapshotView,
		showHideSnapshotViewValue: storeState.showHideRightSideSnapshotView
	};
}
function mapDispatch(dispatch) {
	return {
		actions: bindActionCreators(Object.assign({}, snapshotsactions, snapshotdetailsactions), dispatch)
	};
}

export default connect(mapState, mapDispatch)(CanvasFormSnapshotRightSideView);

const StyledCanvasFormChanges = styled.section`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
	width: calc(50% - var(--px-5));
	padding-left: var(--px-10);
	background-color: var(--neutrals-25);
	&.HideView {
		display: none;
	}
	&.FullView {
		width: 100%;
		.entity-content.entity-content-level-1 {
			.scotEntityContentMain {
				width: calc(100% - var(--px-150)) !important;
				padding-right: var(--px-10);
			}
			.controlEntityContentMain {
				width: calc(100% - var(--px-205)) !important;
			}
			.entity-content-data {
				&.ThirdCol {
					max-width: unset;
					min-width: unset;
				}
			}
			&.RelatedRisksContainer {
				.tree-trigger-children {
					.RelatedRisksCol {
						max-width: calc(100% - var(--px-225));
					}
					.entity-content-data {
						width: unset;
						min-width: unset;
						max-width: unset;
						margin-left: var(--px-10);
					}
				}
			}
			&.ControlRelatedObject {
				&.RelatedRisksContainer {
					.tree-trigger-children {
						.RelatedRisksCol {
							width: calc(100% - var(--px-200));
						}
						.entity-content-data {
							width: unset !important;
							min-width: unset;
							max-width: unset;
							margin-left: var(--px-17);
						}
					}
				}
			}
		}
	}
	&.HalfView {
		.entity-content.entity-content-level-1 {
			.scotEntityContentMain {
				width: calc(100% - var(--px-150)) !important;
				padding-right: var(--px-10);
			}
			.controlEntityContentMain {
				width: 100% !important;
			}
			.entity-content-data {
				&.ThirdCol {
					max-width: unset;
					min-width: unset;
				}
			}
			&.ControlRelatedObject {
				&.RelatedRisksContainer {
					.tree-trigger-children {
						.RelatedRisksCol {
							width: calc(100% - var(--px-200));
						}
					}
				}
			}
		}
		.isa315-relate-itprocess-itapplications-body {
			.isa315-relate-itprocess-itapplist-title-list-toolbar {
				align-items: center;
				.motif-search-input-wrapper {
					.motif-typeahead {
						.motif-input {
							width: 100% !important;
						}
					}
				}
				.StyledClickableIconLabel {
					display: none;
				}
			}
			.isa315-relate-itprocess-itapplist-title {
				.isa315-relate-itprocess-unassociated {
					display: none;
				}
			}
			.StyledISA315RelateItProcessItAppListItem {
				.header-section {
					.isa315relateitprocessitappentitynameitem {
						width: calc(100% - var(--px-40));
					}
					.isa315relateitprocessitapplistitem {
						display: none;
					}
					.StyledBodySpecialAccordionHeaderOverflow {
						.motif-dropdown-portal {
							display: flex;
							.motif-dropdown-trigger {
								display: flex;
							}
						}
					}
				}
			}
		}
		.StyledISA315ScotItApplicationBodyListWrapper {
			.StyledISA315ScotItApplicationBodyListItem {
				.StyledBodySpecialAccordionHeader {
					.ScotColumnHeader {
						width: calc(100% - var(--px-350));
					}
					.StrategyColumnHeader {
						display: none;
					}
				}
			}
		}
		.isa315-itapp-scot-body-itapp-list {
			.isa315-itapp-scot-body-itapp-item {
				.StyledBodySpecialAccordionHeader {
					.ItAppColumnHeader {
						width: calc(100% - var(--px-150));
					}
					.ControlsCountColumnHeader {
						display: none;
					}
				}
			}
		}
		.StyledISA315ItGCTestStrategyList {
			.StyledBodySpecialAccordionHeader {
				.ITProcessHeader {
					width: calc(100% - var(--px-210));
				}
				.ControlsGroup1 {
					display: none;
				}
			}
		}
		.StyledBodySpecialManageITSP {
			.isa315-itprocess-itrisk-list {
				.StyledBodySpecialAccordionHeader {
					.ItProcessColumnHeader {
						width: calc(100% - var(--px-200));
					}
					.ControlsGroup1 {
						display: none;
					}
				}
			}
		}
		.StyledISA315ItProcessItRiskList {
			.StyledBodySpecialAccordionHeader {
				.ItProcessColumnHeader {
					width: calc(100% - var(--px-320));
				}
				.ControlsGroup1 {
					display: none;
				}
			}
		}
	}
	.SharedFormLabel {
		margin: var(--px-20) var(--px-20) 0 var(--px-20);
		width: calc(100% - var(--px-25));
		box-shadow: 0 0 var(--px-6) 0 rgba(0, 0, 0, 0.2);
		.SharedFormLabelText {
			font-size: var(--px-14);
		}
	}
	.SelectedCanvasFormHeader {
		padding: 0;
		display: flex;
		align-items: center;
		width: calc(100% - var(--px-3));
		.selectedCanvasFormHeaderWrapper {
			display: flex;
			width: calc(100% - var(--px-150));
		}
		.FormTitleHeader {
			font-size: var(--px-16);
			margin: 0;
			display: inline-flex;
			width: calc(100% - var(--px-30));
			padding-right: var(--px-20);
			height: var(--px-24);
		}
		.header-validation {
			min-width: var(--px-65);
			height: var(--px-24);
		}
		.RightSideHeader {
			display: flex;
			width: var(--px-150);
			margin-left: auto;
			.header-validation {
				min-width: var(--px-65);
				height: var(--px-20);
			}
			.BadgeTextWrapper {
				margin-left: unset;
			}
			.custom-labels {
				display: flex;
				align-items: center;
				margin: 0;
				margin-left: auto;
				height: var(--px-24);
				min-width: var(--px-35);
				svg {
					width: var(--px-20) !important;
					height: var(--px-20) !important;
					padding: 0;
				}
				.hiddenIcon {
					display: none;
				}
				.showIcon {
					display: inline-block;
				}
				.edit-icon {
					margin-right: var(--px-10);
					height: var(--px-20);
				}
				.motif-dropdown {
					height: var(--px-24);
					margin: 0;
				}
			}
		}
	}
	.sectionIncompletePadding {
		padding-left: var(--px-30);
	}
	.bodyIncompletePadding {
		padding-left: 0;
	}
	.selectDropdown {
		display: inline-flex;
		width: calc(100% - var(--px-150));
		@media only screen and (max-width: 1280px) {
			width: calc(100% - var(--px-162));
		}
	}
	.CanvasFormChangesHeader {
		display: flex;
		padding: 0 0 var(--px-10) 0;
		width: 100%;
		.CanvasFormCurrentChangesHeader {
			display: flex;
			align-items: center;
			width: 100%;
			.CanvasFormChangesSelect {
				width: 85%;
				.react-select-container {
					.react-select__menu {
						z-index: 99;
					}
				}
				.selectText {
					display: flex;
					padding-right: var(--px-30);
					.ellipses {
						&#snapshotOptionNameLabel {
							width: 75%;
							padding-top: var(--px-4);
						}
					}
					.ellipses {
						&#snapshotOptionDateLabel {
							width: 25%;
							justify-content: flex-end;
						}
					}
				}
			}
			.IconPrint {
				margin-left: var(--px-20);
				cursor: pointer;
				&.disabled {
					pointer-events: none;
					cursor: not-allowed;
					svg {
						fill: var(--neutrals-200);
					}
				}
			}
			.IconToggleView {
				margin-left: auto;
				&.disabled {
					pointer-events: none;
					cursor: not-allowed;
					svg {
						fill: var(--neutrals-200);
					}
				}
			}
		}
		.CanvasFormSnapshotChangesHeader {
			display: flex;
			align-items: center;
			width: 100%;
			.CanvasFormChangesSelect {
				width: 85%;
				.react-select-container {
					.react-select__menu {
						z-index: 99;
					}
				}
				.selectText {
					display: flex;
					padding-right: var(--px-30);
					.ellipses {
						&#snapshotOptionNameLabel {
							width: 75%;
							padding-top: var(--px-4);
						}
					}
					.ellipses {
						&#snapshotOptionDateLabel {
							width: 25%;
							justify-content: flex-end;
						}
					}
				}
			}
			.CanvasFormChangesSelect label {
				top: var(--px-5);
			}
			.IconToggleView {
				margin-left: auto;
				.motif-icon {
					svg {
						width: var(--px-24);
						height: var(--px-24);
					}
				}
				&.disabled {
					pointer-events: none;
					cursor: not-allowed;
					svg {
						fill: var(--neutrals-200);
					}
				}
			}
		}
	}
	.CanvasFormChangesBody {
		display: flex;
		width: 100%;
		padding: var(--px-10) 0 0 0;
		height: calc(100% - var(--px-60));
		.CanvasFormCurrentChangesBody {
			display: flex;
			width: 100%;
			.SectionBodyData {
				button.toggleButton {
					min-width: 18% !important;
					max-width: 30% !important;
				}
			}
			&.FullViewCurrent {
				width: 99.7%;
				padding: 0;
			}
			&.FullViewSnapshot {
				&.CanvasFormCurrentChangesBody {
					width: 0;
					padding: 0;
				}
			}
			.SelectedCanvasFormBody {
				padding: 0;
				height: initial;
				.SectionBodyAccordion {
					width: calc(100% - var(--px-5));
					margin: 0 var(--px-5) var(--px-15) 0;
					&:hover {
						box-shadow: var(--px-1) var(--px-2) var(--px-6) var(--px-2) rgba(0, 0, 0, 0.22);
					}
					.accordionWrapper {
						padding: var(--px-10);
						cursor: pointer;
						.SelectedCanvasFormHeader {
							width: 100%;
						}
						.plusminusIcons {
							margin-right: var(--px-5);
						}
						.section-Wrapper {
							width: calc(100% - var(--px-112));
							margin-right: var(--px-10);
						}
						.ValidationIcon {
							svg {
								vertical-align: middle;
							}
							.validationcount {
								top: calc(var(--px-3) * -1);
							}
						}
					}
					.SelectedCanvasFormBody {
						width: 100%;
						.SectionBodyAccordion {
							&:last-child {
								margin-bottom: 0;
							}
						}
					}
					.FormBodyContainer {
						.SectionBodyWrapper {
							.section-showless-header {
								width: 100%;
								margin-right: var(--px-20);
							}
							.BadgeTextWrapper {
								display: inline-block;
							}
						}
						.section-container {
							.SectionBodyDescription {
								.section-showless-header {
									width: calc(100% - var(--px-80));
									line-height: normal;
								}
							}
						}
						.bodyWrapper {
							&.DefaultView:last-child {
								margin-bottom: 0;
							}
							.StyledBodySpecialFetch {
								min-height: unset;
								.StyledBodySpecialPagination {
									margin: 0;
								}
							}
						}
					}
					.SelectedCanvasFormBody {
						padding: var(--px-10);
						height: initial;
						overflow: initial;
						.SectionBodyAccordion {
							width: 100%;
							margin-bottom: var(--px-10);
							.section-Wrapper {
								width: calc(100% - var(--px-105)) !important;
							}
						}
					}
				}
			}
		}
		.CanvasFormSnapshotChangesBody {
			display: flex;
			width: 100%;
			position: relative;
			.motif-progress-loader {
				flex-direction: column;
				top: 40%;
				left: 40%;
			}
			&.FullViewSnapshot {
				width: 99.7%;
				padding: 0;
			}
			&.FullViewCurrent {
				&.CanvasFormSnapshotChangesBody {
					width: 0;
					padding: 0;
				}
			}
			.SelectedCanvasFormBody {
				padding: 0;
				width: 100%;
				.SectionBodyAccordion {
					width: 100%;
					margin-bottom: var(--px-15);
					border: var(--px-1) solid var(--neutrals-300);
					.accordionWrapper {
						padding: var(--px-10);
						cursor: pointer;
						.plusminusIcons {
							margin-right: var(--px-5);
						}
						.sectionName {
							font-size: var(--px-16);
						}
					}
					.SelectedCanvasFormBody {
						padding: var(--px-10) var(--px-10) 0 var(--px-10);
						height: initial;
						.SectionBodyAccordion {
							width: 100%;
							margin-bottom: var(--px-10);
							min-height: var(--px-46);
							padding: 0 0 0 var(--px-10);
							.RelatedObjectWrapperContainer {
								.body-container {
									.WcgwRelatedObject {
										.ControlRelatedObject {
											.entity-content-main {
												width: calc(100% - var(--px-70)) !important;
											}
										}
									}
									.tree-trigger-children {
										width: calc(100% - var(--px-20)) !important;
									}
									.WcgwRelatedObjectWrapper {
										width: calc(100% - var(--px-70)) !important;
									}
									.ITApplicationRelatedObject {
										.Entity-content-list {
											display: flex;
											width: 100%;
											.entity-content-main {
												width: calc(100% - var(--px-80)) !important;
											}
											.entity-content-data {
												&.SecondCol {
													&.remove-btn {
														display: inline-flex;
														justify-content: flex-end;
														min-width: var(--px-50) !important;
														width: auto !important;
														max-width: var(--px-80);
														padding: 0;
														margin-left: auto;
													}
												}
											}
										}
									}
									.RiskRelatedObject {
										.entity-content-main {
											width: calc(100% - var(--px-70));
										}
									}
									.ControlRelatedObject {
										&.entity-content-level-1 {
											.tree-trigger-children {
												.entity-content-main {
													width: calc(100% - var(--px-70)) !important;
												}
											}
										}
									}
								}
							}
							.section-container {
								.SectionBodyDescription {
									.section-showless-header {
										width: calc(100% - var(--px-80));
										.richText-Body {
											width: 100% !important;
											line-height: normal;
										}
									}
								}
							}
							.FormBodyContainer {
								.section-body {
									min-height: 10rem;
									.motif-progress-loader {
										top: 0;
										left: 0;
									}
									.section-container {
										.SectionBodyData {
											min-width: 30%;
											max-width: 100%;
										}
									}
								}
							}
						}
					}
				}
			}
		}
		.section-freeText {
			font-size: inherit;
			width: 100%;
			line-height: normal;
			ins {
				font-size: inherit;
				line-height: normal;
				del {
					font-size: inherit;
				}
			}
			del {
				font-size: inherit;
			}
			div {
				font-size: inherit;
				del {
					font-size: inherit;
				}
				strong {
					font-size: inherit;
				}
				em {
					font-size: inherit;
				}
			}
			p {
				font-size: inherit;
				line-height: normal;
				margin-bottom: 0 !important;
				min-height: var(--px-16);
				span {
					line-height: normal;
					font-size: inherit;
				}
				strong {
					font-size: inherit;
				}
				em {
					font-size: inherit;
				}
				del {
					font-size: inherit;
				}
			}
			span {
				width: 100%;
				color: var(--neutrals-900);
				font-size: inherit;
				line-height: normal;
				div {
					font-size: inherit;
					line-height: var(--px-16);
				}
				blockquote {
					font-size: inherit;
					line-height: var(--px-16);
				}
				ul {
					display: block;
					list-style-type: disc;
					margin-block-end: var(--px-10);
					margin-block-start: 0;
					margin-bottom: var(--px-10);
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin-top: 0;
					padding-inline-start: var(--px-24);
					padding-left: var(--px-24);
					li {
						font-size: inherit;
						margin-bottom: calc(var(--px-3) * -1);
						font-weight: 500;
						list-style-type: disc;
					}
				}
				ol {
					margin-block-end: var(--px-10);
					margin-block-start: 0;
					margin-bottom: var(--px-10);
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin-top: 0;
					padding-inline-start: var(--px-24);
					padding-left: var(--px-24);
					li {
						font-size: inherit;
						margin-bottom: calc(var(--px-3) * -1);
						font-weight: 500;
					}
				}
				h6 {
					font-weight: bold;
					line-height: var(--px-32);
					margin-block-end: 0;
					margin-block-start: 0;
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin: 0;
					padding: 0;
					em {
						line-height: var(--px-40);
					}
				}
				h5 {
					font-weight: bold;
					line-height: var(--px-32);
					margin-block-end: 0;
					margin-block-start: 0;
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin: 0;
					padding: 0;
					em {
						line-height: var(--px-40);
					}
				}
				h4 {
					font-weight: bold;
					font-size: inherit;
					line-height: var(--px-32);
					margin-block-end: 0;
					margin-block-start: 0;
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin: 0;
					padding: 0;
					em {
						font-size: inherit;
						line-height: var(--px-40);
					}
				}
				h3 {
					font-weight: bold;
					line-height: var(--px-32);
					margin-block-end: 0;
					margin-block-start: 0;
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin: 0;
					padding: 0;
					em {
						line-height: var(--px-40);
					}
				}
				h2 {
					font-weight: bold;
					line-height: var(--px-40);
					margin-block-end: 0;
					margin-block-start: 0;
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin: 0;
					padding: 0;
					em {
						line-height: var(--px-50);
					}
				}
				h1 {
					font-weight: bold;
					line-height: var(--px-48);
					margin-block-end: 0;
					margin-block-start: 0;
					margin-inline-end: 0;
					margin-inline-start: 0;
					margin: 0;
					padding: 0;
					em {
						line-height: var(--px-60);
					}
				}
			}
			tr,
			th,
			td {
				font-weight: 500;
				font-size: inherit;
				padding: var(--px-2) var(--px-3);
				border: var(--px-1) solid var(--neutrals-300);
				border-collapse: collapse;
				background-color: transparent;
				span {
					font-size: inherit;
				}
			}
			table {
				width: calc(100% - var(--px-100));
				border-collapse: collapse;
				background-color: transparent;
			}
			span {
				div {
					word-break: break-all;
				}
			}
			.k-table {
				table-layout: fixed;
				word-break: break-all;
			}
		}
	}
`;
